@if (showOverflowMenu$ | async) {
  <button
    data-automation-id="overflow-menu"
    cdkOverlayOrigin
    #trigger="cdkOverlayOrigin"
    aria-haspopup="true"
    [title]="menuLabel$ | async"
    [attr.aria-expanded]="menuOpen$ | async"
    class="btn btn-icon kebab-button"
    (click)="openMenu()"
    type="button"
    aria-controls="teacher-options"
    >
    <span class="kebab-menu-icon"></span>
    <!-- TODO remove later: This icon uses the ngx-shared 9 and it's breaking the UI -->
    <!-- <i class="dpg-icon dpg-icon-system-kebab"></i> -->
  </button>
  <!-- menu overlay -->
  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="trigger"
    [cdkConnectedOverlayPositions]="connectionPositions"
    [cdkConnectedOverlayOffsetY]="5"
    [cdkConnectedOverlayHasBackdrop]="true"
    [cdkConnectedOverlayBackdropClass]="rdrxMeneBackDropClass"
    [cdkConnectedOverlayOpen]="menuOpen$ | async"
    (backdropClick)="menuClickOutside($event)"
    (attach)="onAttach()"
    (detach)="onDetach()"
    >
    <div class="rdrx-menu" data-automation-id="menu-container" cdkTrapFocus [cdkTrapFocusAutoCapture]="true">
      <!-- teacher options -->
      @if (teacherOptions$ | async; as teacherOptions) {
        <div role="menu" data-automation-id="overflow-menu-teacher-options" class="grouped-list" (keydown)="keyNavigation($event)" id="teacher-options">
          @for (option of teacherOptions; track trackByOptionValue($index, option)) {
            <button
              data-automation-id="overflow-menu-teacher-option-button"
              class="rdrx-menu-item"
              role="menuitem"
              [id]="option?.value"
              [rdrxMenuItem]="option"
              (click)="optionSelected(option)"
              >
              {{ option.viewValue | translate }}
            </button>
          }
        </div>
      }
      <!-- leveled content -->
      @if (contentLevelOptions$ | async; as levelOptions) {
        @if (levelOptions.length) {
          <fieldset class="grouped-list with-label">
            <legend class="group-label">
              {{ 'levelText.level_selection' | translate | titlecase }}
            </legend>
            <ul
              role="menu"
              data-automation-id="overflow-menu-content-levels"
              tabindex="0"
              (keydown)="levelContentKeyDown($event)"
              (focus)="levelOptionsFocus($event)"
              >
              @for (level of levelOptions; track trackByOptionValue($index, level)) {
                <li>
                  <button
                    data-automation-id="overflow-menu-content-level-button"
                    class="rdrx-menu-item"
                    role="menuitemradio"
                    tabindex="-1"
                    [rdrxMenuItem]="level"
                    [attr.aria-checked]="level.active"
                    (click)="contentLevelSelected(level.value)"
                    >
                    {{ level.viewValue }}
                  </button>
                </li>
              }
            </ul>
          </fieldset>
        }
      }
      <!-- lexile levels -->
      @if (lexileLevelOptions$ | async; as levelOptions) {
        @if (levelOptions.length) {
          <fieldset class="grouped-list with-label">
            <legend class="group-label">
              Lexile {{ 'levelText.level_selection' | translate | titlecase }}
            </legend>
            <ul
              role="menu"
              data-automation-id="overflow-menu-lexile-levels"
              tabindex="0"
              (keydown)="levelContentKeyDown($event)"
              (focus)="levelOptionsFocus($event)"
              >
              @for (level of levelOptions; track trackByOptionValue($index, level)) {
                <li>
                  <button
                    data-automation-id="overflow-menu-lexile-level-button"
                    class="rdrx-menu-item"
                    role="menuitemradio"
                    tabindex="-1"
                    [rdrxMenuItem]="level"
                    [attr.aria-checked]="level.active"
                    (click)="lexileLevelSelected(level.value)"
                    >
                    {{ level.viewValue }}
                  </button>
                </li>
              }
            </ul>
          </fieldset>
        }
      }
    </div>
  </ng-template>
}
